/* eslint-disable
    eqeqeq,
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { CardView } from 'app/scripts/views/card/CardView';
import { CollectionView } from 'app/scripts/views/internal/CollectionView';
import { View } from 'app/scripts/views/internal/View';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { boardModelIdToElementState } from 'app/src/boardModelIdToElementState';
import { isBoardCanvasModernizationEnabled } from 'app/src/isBoardCanvasModernizationEnabled';

interface CardListView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubviews: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debounce: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debouncedRefreshIfInitialized: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  existingSubviewOrUndefined: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewType: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  waitForId: any;
}

class CardListView extends CollectionView {
  static initClass() {
    this.prototype.viewType = CardView;
  }

  getModels() {
    return this.collection.models;
  }

  constructor() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super(...arguments);

    this.debouncedRefreshIfInitialized = this.debounce(
      this.refreshIfInitialized,
      10,
    );
  }

  initialize() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.initialize(...arguments);

    this.listenTo(this.collection, 'change:idBoard', (card, idBoard) => {
      // @ts-expect-error
      if (idBoard !== this.collection.list.get('idBoard')) {
        // The card (or possibly the list the card is on) is being moved
        // to another board.  We don't want to render the card in this
        // view anymore (it shouldn't be displayed on whatever list we're
        // rendering, and if we try to render it it'll have errors if
        // we haven't loaded the new board, e.g. if the new board is one
        // we can't see)
        // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
        this.removeModel(card);
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeModel(model: any, options: any) {
    // We may have pre-emptively removed the card from this view
    // when we saw that it moved to another board, in which case
    // we don't need to worry about removing it again
    if (!this.existingSubviewOrUndefined(this.viewType, model)) {
      return;
    }

    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    return super.removeModel(...arguments);
  }

  render() {
    if (this.options.deferCards) {
      // If our whole list is not initial visible, wait to render any of
      // these cards
      // @ts-expect-error TS(2345): Argument of type '() => void' is not assignable to... Remove this comment to see the full error message
      this.whenIdle(`deferredCardList_${this.cid}`, () => {
        return this.progressiveRender();
      });
    } else {
      this.progressiveRender();
    }

    return this;
  }

  progressiveRender() {
    const allModels = this.getModels();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const append = (models: any, renderFullCard = true) => {
      return this.appendSubviews(
        Array.from(models).map((model) => {
          // @ts-expect-error TS(2554): Expected 0 arguments, but got 3.
          const subview = this.subview(this.viewType, model, {
            renderFullCard,
          });

          this.trigger('subviewAdded', subview);
          return subview;
        }),
      );
    };

    const maxVisibleCards = Math.max(10, Math.ceil(window.innerHeight / 32)); // Hard-coded minimum card height
    // break down appending to DOM in chunks so that we don't flash content on paint.
    // Ie, if we passed false for rendering full card, intersection observer would paint
    // a full card *after* it rendered the minimal, which would flash.
    const firstVisible = allModels.slice(0, maxVisibleCards);
    // render the first 5 cards, so that cards out of viewport can detect that correctly
    // if the first few images have covers
    append(firstVisible.slice(0, 5));
    // append the next set of visible cards and pass false to render minimal
    // and let IntersectionObserver in CardView handle whether or not to do full render.
    append(firstVisible.slice(5, maxVisibleCards - 5), false);

    // append the rest when idle, since they are out of view and expensive to render
    return this.whenIdle(`deferredHiddenCards_${this.cid}`, () =>
      append(allModels.slice(maxVisibleCards - 5, allModels.length), false),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertSubview(subview: any, target: any, $el: any) {
    if ($el == null) {
      ({ $el } = this);
    }
    // Turn target from an index or a view into an element
    if (typeof target === 'number') {
      if (target <= 0) {
        target = $el.children().eq(0);
      } else if (target < $el.children().length) {
        target = $el.children().eq(target);
      } else {
        target = undefined;
      }
    } else if (target instanceof View) {
      target = target.$el;
    }

    const card = subview.model;

    if (subview.$el.is(':empty')) {
      // If the subview is empty then it needs to be rendered.
      subview.delegateEvents();
      subview.render();
    } else if (
      !$el.hasClass('hide') &&
      !card.getBoard().filter.satisfiesFilter(card)
    ) {
      // If the subview is rendered but meant to be filtered, then call renderFiltered()
      subview.renderFiltered();
    }

    if ((target != null ? target.length : undefined) > 0) {
      subview.$el.insertBefore(target);
    } else {
      $el.append(subview.$el);
    }

    this.waitForId(subview.model, () => {
      this.trigger('subviewAdded', subview);
    });

    return this.debouncedRefreshIfInitialized();
  }

  refreshIfInitialized() {
    return DragSort.refreshIfInitialized(this.$el);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  scrollToCardView(card: any) {
    if (!isBoardCanvasModernizationEnabled()) {
      const cardSubview = this.viewForModel(card);
      if (cardSubview) {
        cardSubview.el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      return;
    }

    const cardElement = boardModelIdToElementState.value.cards.get(card.id);

    if (!cardElement) {
      return;
    }

    cardElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
CardListView.initClass();

export { CardListView };
